import { ImageScaleView } from '@play-co/timestep-core/ui';
import { Container, Sprite } from '../../../odie';
import { ColorId, CurtainBlockProps } from '../../defs/block';
import { blockPositionView } from '../../util/blockTools';
import { config } from '../../defs/config';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';

const nineSlice = [
  [
    'curtain/block.curtain.left.png',
    'curtain/block.curtain.top.png',
    'curtain/block.curtain.right.png',
  ],
  [
    'curtain/block.curtain.center.png',
    'curtain/block.curtain.center.png',
    'curtain/block.curtain.center.png',
  ],
  [
    'curtain/block.curtain.bottom.png',
    'curtain/block.curtain.bottom.png',
    'curtain/block.curtain.bottom.png',
  ],
];

/*
   Curtain block view
*/
export class CurtainBlockView extends Container {
  private _sprite: Sprite;
  private _counter!: LangBitmapFontTextView;
  private _rope: ImageScaleView[] = [];
  private _gem!: ImageScaleView;
  private _gemRopeCounter: Container;

  constructor(private props: CurtainBlockProps) {
    super();

    this._sprite = this.createSprite();
    this.width = props.width * config.tile.size;
    this.height = props.height * config.tile.size;
    this.addChild(this._sprite);
    this._gemRopeCounter = this.createGemRopeCounter();
    this._gemRopeCounter.y = -this.height / 2;
    this.addChild(this._gemRopeCounter);

    blockPositionView(this, props);
  }

  public static assets(): string[] {
    return nineSlice.flat();
  }

  private createSprite() {
    const sprite = new Sprite();

    const { width, height } = this.props;
    const offsetX = (width * config.tile.size) / 2;
    const offsetY = (height * config.tile.size) / 2;

    for (let x = 0; x < width; x++) {
      for (let y = 0; y < height; y++) {
        const textureX = x === 0 ? 0 : x === width - 1 ? 2 : 1;
        const textureY = y === 0 ? 0 : y === height - 1 ? 2 : 1;
        const texture = nineSlice[textureY][textureX];
        const paddedSize = config.tile.size + 2;

        const positionX = x * config.tile.size - offsetX;
        const positionY = y * config.tile.size - offsetY;

        new ImageScaleView({
          superview: sprite.view,
          image: `assets/minigame/match2/puzzle/blocks/${texture}`,
          width: paddedSize,
          height: paddedSize,
          x: positionX,
          y: positionY,
        });
      }
    }

    return sprite;
  }

  private createGemRopeCounter() {
    const container = new Container();
    const tileHeight = this.height / config.tile.size;
    const ropes = Math.floor(tileHeight / 2);
    const singleRopeHeight = config.tile.size;

    for (let i = 0; i < ropes; i++) {
      this._rope.push(
        new ImageScaleView({
          superview: container.view,
          image: `assets/minigame/match2/puzzle/blocks/curtain/block.curtain.rope.png`,
          width: 16,
          height: singleRopeHeight,
          centerOnOrigin: true,
          x: 2,
          y: i * singleRopeHeight + 55,
        }),
      );
    }

    this._rope.push(
      new ImageScaleView({
        superview: container.view,
        image: `assets/minigame/match2/puzzle/blocks/curtain/block.curtain.hanger.png`,
        width: 17,
        height: 17,
        centerOnOrigin: true,
        x: 0,
        y: 15,
      }),
    );

    const gem = new ImageScaleView({
      superview: container.view,
      image: `assets/minigame/match2/puzzle/blocks/curtain/block.curtain.${this.props.color}.png`,
      width: 63,
      height: 73,
      centerOnOrigin: true,
      x: 0,
      y: this.height / 2 + 10,
    });
    this._gem = gem;

    this._counter = new LangBitmapFontTextView({
      superview: gem,
      width: gem.style.width,
      height: gem.style.height,
      align: 'center',
      verticalAlign: 'center',
      localeText: () => this.props.count.toString(),
      font: 'Body',
      size: 28,
      x: -3,
      y: -2,
    });

    return container;
  }

  public updateCounter(count: number) {
    this._counter.localeText = () => count.toString();

    if (count === 0) {
      this._rope.forEach((rope) => {
        rope.hide();
      });
      this._gem.hide();
    }
  }

  public updateColor(color: ColorId) {
    this._gem.updateOpts({
      image: `assets/minigame/match2/puzzle/blocks/curtain/block.curtain.${color}.png`,
    });
  }
}
